import ChevronDown from '@/components/icons/chevron-down'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import apiGet from '@/store/helpers/api-get'
import { useParams } from 'next/navigation'
import useSWR from 'swr'

export default function RoundSelector({ round, setRound }) {
  const params = useParams()

  const { data: rounds } = useSWR(
    {
      url: '/analytics/rounds',
      query: {
        seasonId: decodeURIComponent(params.seasonId),
      },
    },
    apiGet,
  )

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          className="flex items-center gap-2 px-2 py-1 text-footer font-semibold desktop-xs:px-4 desktop-xs:py-3 desktop-xs:text-p-1"
        >
          {round?.round_name || 'All Rounds'}{' '}
          <ChevronDown className="size-4 stroke-white stroke-2" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="">
        <DropdownMenuLabel>Rounds</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {rounds && (
          <DropdownMenuRadioGroup value={round} onValueChange={setRound}>
            {['All Rounds', ...rounds].map((r) => (
              <DropdownMenuRadioItem
                value={r || 'All Rounds'}
                key={`main-selector-${r?.event_id || r}`}
              >
                {r?.event_id ? `${r?.round_name}: ${r?.track}` : r}
              </DropdownMenuRadioItem>
            ))}
          </DropdownMenuRadioGroup>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
